(function () {
    window.sharkDmxCmp = function (id) {
        if (typeof dmx === 'undefined' || !dmx.app) return null;
        if (dmx.app[id]) return dmx.app[id];
        if (typeof dmx.app.find === 'function') {
            var found = dmx.app.find(id);
            if (found) return found;
        }
        if (dmx.app.data && typeof dmx.app.data === 'object') {
            for (var key in dmx.app.data) {
                var scope = dmx.app.data[key];
                if (scope && typeof scope === 'object' && scope[id]) return scope[id];
            }
        }
        var node = document.getElementById(id);
        return (node && node.dmxComponent) || null;
    };
    window.sharkSrvProductData = function () {
        var srv = window.sharkDmxCmp('srvGetProduct');
        if (!srv) return null;
        if (srv.data && (srv.data.properties || srv.data.product)) return srv.data;
        if (srv.data && srv.data.data && (srv.data.data.properties || srv.data.data.product)) return srv.data.data;
        if (typeof dmx !== 'undefined' && dmx.app && dmx.app.data) {
            var s = dmx.app.data.srvGetProduct;
            if (s && (s.properties || s.product)) return s;
            if (s && s.data && (s.data.properties || s.data.product)) return s.data;
        }
        return null;
    };
})();
